"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var rql_1 = require("../../schemas/rql");
var parse_graphql_errors_1 = require("@reverbdotcom/commons/dist/parse_graphql_errors");
function submitCheckoutIdentifyShopper(input, mutation, callbacks) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var result, _a, paymentStatus, challengeToken, paymentResultUrl, error_1;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, mutation({ variables: { input: input } })];
                case 1:
                    result = _b.sent();
                    _a = result.data.checkoutIdentifyShopper.adyenPaymentResult, paymentStatus = _a.paymentStatus, challengeToken = _a.challengeToken;
                    paymentResultUrl = result.data.checkoutIdentifyShopper.paymentResultUrl;
                    if (paymentStatus === rql_1.core_apimessages_AdyenPaymentResult_PaymentStatus.CHALLENGE_SHOPPER_REQUIRED) {
                        callbacks.onChallengeShopperRequired(challengeToken);
                    }
                    else if (paymentStatus === rql_1.core_apimessages_AdyenPaymentResult_PaymentStatus.SUCCESS) {
                        callbacks.onSuccess(paymentResultUrl);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    callbacks.onError(parse_graphql_errors_1.parseGraphqlErrors(error_1));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.submitCheckoutIdentifyShopper = submitCheckoutIdentifyShopper;
function submitCheckoutChallengeShopper(input, mutation, callbacks) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var result, paymentStatus, paymentResultUrl, error_2;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, mutation({ variables: { input: input } })];
                case 1:
                    result = _a.sent();
                    paymentStatus = result.data.checkoutChallengeShopper.adyenPaymentResult.paymentStatus;
                    paymentResultUrl = result.data.checkoutChallengeShopper.paymentResultUrl;
                    if (paymentStatus === rql_1.core_apimessages_AdyenPaymentResult_PaymentStatus.SUCCESS) {
                        callbacks.onSuccess(paymentResultUrl);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    callbacks.onError(parse_graphql_errors_1.parseGraphqlErrors(error_2));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.submitCheckoutChallengeShopper = submitCheckoutChallengeShopper;
function submitGuestCheckoutIdentifyShopper(input, mutation, callbacks) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var result, _a, paymentStatus, challengeToken, paymentResultUrl, error_3;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, mutation({ variables: { input: input } })];
                case 1:
                    result = _b.sent();
                    _a = result.data.guestCheckoutIdentifyShopper.adyenPaymentResult, paymentStatus = _a.paymentStatus, challengeToken = _a.challengeToken;
                    paymentResultUrl = result.data.guestCheckoutIdentifyShopper.paymentResultUrl;
                    if (paymentStatus === rql_1.core_apimessages_AdyenPaymentResult_PaymentStatus.CHALLENGE_SHOPPER_REQUIRED) {
                        callbacks.onChallengeShopperRequired(challengeToken);
                    }
                    else if (paymentStatus === rql_1.core_apimessages_AdyenPaymentResult_PaymentStatus.SUCCESS) {
                        callbacks.onSuccess(paymentResultUrl);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _b.sent();
                    callbacks.onError(parse_graphql_errors_1.parseGraphqlErrors(error_3));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.submitGuestCheckoutIdentifyShopper = submitGuestCheckoutIdentifyShopper;
function submitGuestCheckoutChallengeShopper(input, mutation, callbacks) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var result, _a, adyenPaymentResult, paymentResultUrl, error_4;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, mutation({ variables: { input: input } })];
                case 1:
                    result = _b.sent();
                    _a = result.data.guestCheckoutChallengeShopper, adyenPaymentResult = _a.adyenPaymentResult, paymentResultUrl = _a.paymentResultUrl;
                    if (adyenPaymentResult.paymentStatus === rql_1.core_apimessages_AdyenPaymentResult_PaymentStatus.SUCCESS) {
                        callbacks.onSuccess(paymentResultUrl);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _b.sent();
                    callbacks.onError(parse_graphql_errors_1.parseGraphqlErrors(error_4));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.submitGuestCheckoutChallengeShopper = submitGuestCheckoutChallengeShopper;
//# sourceMappingURL=threeds2_checkout_submission.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/threeds2/threeds2_checkout_submission.js
// module id = mxLv
// module chunks = 20 21 22